import { useState } from 'react';

export default function WhyImplants() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const benefits = [
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Permanent replacement for missing teeth',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Restores full chewing function',
    },
    {
      icon: 'ri-shield-line',
      title: 'Prevents bone loss and facial sagging',
    },
    {
      icon: 'ri-lock-line',
      title: 'No slipping or movement, unlike dentures',
    },
    {
      icon: 'ri-palette-line',
      title: 'Custom-designed to match your natural smile perfectly',
    },
    {
      icon: 'ri-brush-line',
      title: 'Easy to maintain with simple brushing & flossing',
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % benefits.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + benefits.length) % benefits.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] text-center mb-16">
          WHY CHOOSE DENTAL IMPLANTS?
        </h2>

        {/* Desktop View - Show All */}
        <div className="hidden lg:grid lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F5F5F0] to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#444c42] leading-relaxed">
                {benefit.title}
              </h3>
            </div>
          ))}
        </div>

        {/* Mobile/Tablet View - Carousel */}
        <div className="lg:hidden relative">
          <div className="bg-gradient-to-br from-[#F5F5F0] to-white p-8 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className={`${benefits[currentIndex].icon} text-3xl text-white`}></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] leading-relaxed text-center">
              {benefits[currentIndex].title}
            </h3>
          </div>

          {/* Navigation Arrows */}
          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={prevSlide}
              className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center hover:bg-[#F5d383] transition-colors cursor-pointer"
              aria-label="Previous benefit"
            >
              <i className="ri-arrow-left-s-line text-2xl text-white"></i>
            </button>
            <div className="flex gap-2">
              {benefits.map((_, index) => (
                <div
                  key={index}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentIndex ? 'bg-[#D0A24F] w-8' : 'bg-[#D0A24F]/30'
                  }`}
                ></div>
              ))}
            </div>
            <button
              onClick={nextSlide}
              className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center hover:bg-[#F5d383] transition-colors cursor-pointer"
              aria-label="Next benefit"
            >
              <i className="ri-arrow-right-s-line text-2xl text-white"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
